import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { PlatformService } from '@ld.consumer-portal/utils';
import { type PartnerConfig, PARTNER_CONFIGS, type PartnerType } from '../partner-disclosure-modal/partner-disclosure-modal.component';

export interface PartnerDisclosureDialogData {
  partnerType: PartnerType;
}

export type PartnerDisclosureDialogResult = { action: 'confirm'; config: PartnerConfig } | { action: 'cancel' };

@Component({
  selector: 'ld-partner-disclosure-dialog',
  templateUrl: './partner-disclosure-dialog.component.html',
  imports: [MatIconModule, TranslocoDirective],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerDisclosureDialogComponent {
  private readonly dialogRef = inject<DialogRef<PartnerDisclosureDialogResult>>(DialogRef);
  private readonly platformService = inject(PlatformService);
  protected readonly data = inject<PartnerDisclosureDialogData>(DIALOG_DATA);

  protected readonly config: PartnerConfig = PARTNER_CONFIGS[this.data.partnerType];

  constructor() {
    if (this.platformService.isNativeMobile()) {
      this.dialogRef.overlayRef.updateSize({ width: '100vw', maxWidth: '100vw' });
    }
  }

  protected onConfirm(): void {
    this.dialogRef.close({ action: 'confirm', config: this.config });
  }

  protected onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }
}
